import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { useRef, useState } from "react";
import audioIcon from "../../images/audio-on.svg";
import audioMuteIcon from "../../images/audio-off.svg";
import excellarateLogo from "../../images/Excellarate logo.svg";
import { LocationData } from "../../types/location";
import { useStyles } from "./HeaderStyles";
import { UserGuide } from "./UserGuide";
import {StepProgressBar} from "./StepProgressBar/StepProgressBar";

export interface IHeader {
  enableCoachMark: boolean;
  locationData: LocationData[];
  getLocation: (currentLocation: string) => void;
  locationInfo: string;
  exit: any;
  experienceStart: any;
  audio: any;
}

export const HeaderComponent = (props: IHeader) => {
  const {
    enableCoachMark,
    locationData,
    getLocation,
    locationInfo,
    exit,
    experienceStart,
    audio,
  } = props;
  const classes = useStyles();
  const [location, setLocation] = useState(locationData[0].value);
  // const handleChange = (event: SelectChangeEvent) => {
  //   setLocation(event.target.value as string);
  //   getLocation(event.target.value);
  // };

  const handleLocationChange = (locatoin: string) => {
    setLocation(locatoin);
    getLocation(locatoin);
  };
  const ref1: any = useRef(null);
  const ref2: any = useRef(null);
  const ref3: any = useRef(null);
  const ref4: any = useRef(null);
  const ref5: any = useRef(null);

  const [showCoachMark, setShowCoachMark] = useState<boolean>(enableCoachMark);
  const [infoContinue, setInfoContinue] = useState<boolean>(true);
  const [audioMute, setAudioMute] = useState<boolean>(true);
  const showInfo = () => {
    setShowCoachMark(!showCoachMark);
    setInfoContinue(false);
  };

  const allRefs: any = {
    ref1: ref1,
    ref2: ref2,
    ref3: ref3,
    ref4: ref4,
    ref5: ref5,
  };

  const audioToggle = () => {
    setAudioMute(!audioMute);
    audio(!audioMute);
  };

  return (
    <Grid className={classes.positionComponent} sx={{ top: "40px !important" }}>
      <Grid
        container
        sx={{
          width: "80%",
          margin: "0 auto",
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center"
        }}
      >
        {showCoachMark ? (
          <UserGuide
            ref={allRefs}
            setShowCoachMark={setShowCoachMark}
            infoContinue={infoContinue}
            experienceStart={experienceStart}
          />
        ) : (
          <></>
        )}
        <Grid
          sx={{
            width: "20%",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            marginTop: "-0.8rem",
          }}
        >
          <img src={excellarateLogo} alt="logo" className={classes.logoStyle} />
        </Grid>
        <Grid
          item
          sx={{ display: "flex", marginTop:'-13px', justifyContent: "center", width: "60%" }}
        >
          {/* <FormControl fullWidth sx={{ width: "250px" }}>
            <Select
              disabled
              // ref={ref1}
              labelId="location-select-label"
              id="location-select"
              value={locationInfo ? locationInfo : location}
              onChange={handleChange}
              className={classes.btnStyle}
              name="location"
              startAdornment={<LocationOnIcon sx={{ marginRight: "1rem" }} />}
              sx={{ width: "282px" }}
              MenuProps={{
                sx: {
                  left: -28,
                },
              }}
            >
              {locationData.map((location, i) => (
                <MenuItem
                  sx={{ width: "270px" }}
                  key={i}
                  value={location.value}
                >
                  {location.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl> */}
          
          <div ref={ref1} style={{width: '55%',  padding:'10px', backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: "12px"}}> 
            <StepProgressBar 
              selectedLocation={locationInfo ? locationInfo : location} 
              locationList={locationData} 
              freeRoamMode={false} 
              handleLocationChange={handleLocationChange}
            />
          </div>
        </Grid>
        <Grid
          item
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            // alignItems: "center",
            gap: "10px",
            width: "20%",
          }}
        >
          <img
            ref={ref2}
            src={audioMute ? audioIcon : audioMuteIcon}
            onClick={audioToggle}
            alt="audioIcon"
            className={classes.audioStyle}
          />
          <IconButton
            ref={ref3}
            onClick={showInfo}
            className={classes.btnStyle}
            aria-label="delete"
            sx={{
              height: '51px',
              width: '52px',
              marginTop: '13px',
            }}
          >
            <InfoOutlinedIcon />
          </IconButton>
          <Button
            ref={ref4}
            onClick={exit}
            className={classes.btnStyle}
            variant="contained"
            startIcon={<LogoutIcon />}
            sx={{
              height: '51px',
              marginTop: '13px',
            }}
          >
            Exit
          </Button>
        </Grid>
        <Grid ref={ref5} className={classes.guideScreen4}></Grid>
      </Grid>
    </Grid>
  );
};
